import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';

import { IframeCommunicationService } from 'src/app/service/iframe';
import { Subscription } from 'rxjs';
import { GlobalComponent } from 'src/app/global/global.component';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from 'src/app/environment.service';

@Component({
  selector: 'app-customer-widget',
  templateUrl: './customer-widget.component.html',
  styleUrls: ['./customer-widget.component.scss'],
 
})
export class CustomerWidgetComponent implements OnInit {
  public settings: Settings;
  public showHoverableChatItem: boolean = false;
  public showChatWindow: boolean = true;
  public chats: Array<any>;
  public talks: Array<any>;
  public interlocutor: string;
  public searchText: string;
  public newChatText: string = '';
  public subscription :Subscription
  public widgetUrl;
  configuration: any;
  constructor(public http: HttpClient, private sanitize: DomSanitizer,public global:GlobalComponent,public appSettings:AppSettings,private iframeCommunicationService: IframeCommunicationService ,  public configurationservice: EnvironmentService,) {
      this.settings = this.appSettings.settings;
      this.configuration = this.configurationservice.getEnvironmentsConfiguration();
  }
  ngOnInit() {
       let CustomerDetails = JSON.stringify({});
        let params = new URLSearchParams();
        params.append("AppColor", "#00786a")
        params.append("CustomerAppCode","CFSS_"+this.global.CFSS_onboardagencycode)
        params.append("CustomerType",  'CLIENT')
        params.append("CustomerId", this.global.cfssLoginEntityId)
        params.append("CustomerName",this.global.fullName)
        params.append("CustomerDetails",  CustomerDetails)
        this.widgetUrl = this.sanitize.bypassSecurityTrustResourceUrl(this.configuration.customerWidgeturl + params );
   
  } 


 


}